import { createReducer } from '@reduxjs/toolkit';

import { setAutocompleteLoading } from 'Core/actions/autocomplete';
import { fromPayload } from 'Core/reducers/common';

export default {
  isLoading: createReducer(false, (builder) => builder.addCase(setAutocompleteLoading, fromPayload)),
};
